var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.show)?_c('div',[_c('h2',[_vm._v("第三方集成相关")]),_c('p',[_vm._v("如需集成帮助，请在技术支持群内提问。")])]):_c('div',[_c('h2',[_vm._v("Third-party integration related")]),_c('p',[_vm._v(" For integration assistance, ask questions in the technical support group.Í ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }